var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RangeWidget as _RangeWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var RangeWidget = (function (_super) {
    __extends(RangeWidget, _super);
    function RangeWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RangeWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return RangeWidget;
}(_RangeWidget));
export { RangeWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/range.widget.ts.pre-build-optimizer.js